export enum StatusFilter {
  ATOMIC_SUGGESTION = "ATOMIC_SUGGESTION",
  CUSTOMER_OWNED = "CUSTOMER_OWNED",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
}
